import { useContext } from 'react';
import StepContext from '../providers/StepContext';

export const useStep = () => {
  const step = useContext(StepContext);
  return step;
}